import type { CreateGameReviewDto, GameReviewListDto, GameReviewParams } from './review.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { GameReviewParamsSchema } from './review.schema';

export const reviewApi = {
  async addReviewForGame(gameId: string, payload: CreateGameReviewDto) {
    return await httpClient.post(ENDPOINTS.reviews.byGame(gameId), payload);
  },
  /*
   * Get reviews for a specific game by gameId
   */
  async getReviewsByGame(gameId: string, params?: GameReviewParams) {
    return await httpClient.get<GameReviewListDto>(ENDPOINTS.reviews.byGame(gameId), {
      params: params ? validateWithZod(GameReviewParamsSchema, params, 'frontend') : undefined,
    });
  },
};
